import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ConsentEmbed from "../ConsentEmbed";

const Section1 = () => {
  const { t } = useTranslation();

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
        ease: "easeInOut"
      },
    },
    exit: {
      transition: { duration: 0, delay: 0 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 , ease: "easeInOut"} },
    exit: { opacity: 0, y: 20, transition: { duration: 0, delay: 0 } },
  };

  const photoVariants = {
    initial: { scale: 1.2, transition: { duration: 3, ease: "easeInOut" } },
    whileInView: { scale: 1, transition: { duration: 3, ease: "easeInOut" } },
    exit: { scale: 1.2, transition: { duration: 0, delay: 0 } },
  };

  return (
    <motion.div 
    initial="hidden"
    whileInView="visible"
    exit="exit"
    variants={containerVariants}
    className="grid grid-cols-10  py-14">
      <div className="col-start-2 col-span-8 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <Link to={'/hakkimizda'} className="block">
          <motion.h5 variants={itemVariants} className="text-45 font-thin tracking-widest">{t("home.about.title")}</motion.h5>

          <div className="space-y-5 mt-10">

            <div className="flex justify-start">
              <motion.img variants={itemVariants} src="/images/icons/comment.svg" className="w-11" />
            </div>

            <motion.p variants={itemVariants} className="text-18 font-light text-customGray">
              {t("home.about.text")}
            </motion.p>

            <div className="flex justify-end">
              <motion.img variants={itemVariants} src="/images/icons/comment.svg" className="w-11" />
            </div>
          </div>

          <div className="">
            <motion.div  variants={itemVariants} className="border inline-block px-10 py-2.5 text-20  border-customGray font-light">
              {t("home.about.button")}
            </motion.div>
          </div>
        </Link>

        <motion.div variants={itemVariants} className="w-full">
          <div className="relative w-full pb-[56.25%] h-0 overflow-hidden">
            <ConsentEmbed
              category="functional"
              title="Doksan Tanıtım Videosu"
              src="https://www.youtube-nocookie.com/embed/7eLOpv0HRUc?autoplay=1&mute=1&loop=1&playlist=7eLOpv0HRUc&playsinline=1"
              className="absolute inset-0 w-full h-full"
              iframeClassName="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Section1;
